import * as Yup from 'yup'

const moveUserToAnotherCompanySchema = Yup.object().shape({
  companyId: Yup.number().required('Please select company below.'),
})

export default moveUserToAnotherCompanySchema
